import React from "react";
import { makeStyles } from "@material-ui/core";
import { Typography, Button } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { history } from "../../../../helpers/index";
import { routePaths } from "../../../config/route-paths";
import { adminService } from "../../../../services/admin.service";
import EUserDetails from "./_e_user_details";
import Skeleton from "@material-ui/lab/Skeleton";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.ePrimary.base,
  },
  innerDiv: {
    display: "block",
      flexDirection: "column",
      padding: "1%",
      overflow: "scroll",
      overflowX: "hidden",
      width: "inherit !important",
      margin: "1% 4%",
      padding: "0% 5%",
      "&::-webkit-scrollbar": {
        width: "0.4em",
      },
      "&::-webkit-scrollbar-track": {
        "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.eLight.base,
        borderRadius: 4,
      },
      [theme.breakpoints.up("xs")]: {
        height: "initial",
      },
      [theme.breakpoints.up("sm")]: {
        height: "25rem",
      },
  },
  backSignup: {
    textTransform: "none",
    color: theme.palette.ePrimary.base,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline",
    display: "inline",
    margin: 0,
    padding: 0,
    "& .MuiSvgIcon-root": {
      fontSize: "0.8rem !important",
    },
  },
  URLtext: {
    color: theme.palette.ePrimary.base+ "!important",
    textDecoration: "none",
  },
  AlignLeft: {
    textAlign: "left !important",
    overflowWrap : 'break-word'
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  Skeleton: {
    marginLeft: "10px",
    width: "90%",
    height: "40%",
  },
  emptyDiv:{
    height:"25rem"
  }
}));
export default function EVerificationFailure(props) {
  const classes = useStyles();
  const supportNumber = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.SUPPORT_CALL_PHONE_NUMBER
  );
  const supportMail = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.CUSTOMER_HELP_EMAIL_ADDRESS
  );
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const {t:Errorlabels, ready: errLabelReady} = useTranslation("label-E_SIGNUP_FAILURE_SCENARIOS");
  const {t:content, ready: contentReady} = useTranslation("content-E_SIGNUP_FAILURE_SCENARIOS")

  const [userdetails, setUserDetails] = useState({});
  useEffect(() => {
    if (props?.location?.state?.data) {
      setUserDetails(props?.location?.state?.data);
    }
  }, [props?.location?.state?.data]);

  let [E_VERFICATION_FAILURE_CONTENT1, setFailureContent1] = useState("");
  let [E_VERIFICATION_FAILURE_ALERT_CONTENT, setAlertContent] = useState(null);
  let [E_VERFICATION_FAILURE_CONTENT2, setFailureContent2] = useState("");
  useEffect(() => {
    if (contentReady && userdetails) {
      setFailureContent1(content("E_VERFICATION_FAILURE_CONTENT1").answer);
      setAlertContent(
        content("E_VERIFICATION_FAILURE_ALERT_CONTENT").answer?.replace("**name**", userdetails?.name)
      .replace("**email**", userdetails?.email)
      .replace("**mobile**", userdetails?.mobileNumber)
      .replace("**accountId**", userdetails?.identificationId)
      );
      setFailureContent2(
        content("E_VERFICATION_FAILURE_CONTENT2").answer?.replace("**contactnumber**", supportNumber)
        .replaceAll("**email**", supportMail)
        .replace("**mailclass**", classes?.URLtext)
      )
    }
  }, [contentReady,userdetails,supportNumber,supportMail]);
  const backtosignup = (e) => {
    e.preventDefault();
    history.push(routePaths.REGISTER);
  };
  return (
    <>
      
        <div className={classes.innerDiv}>
        {
          errLabelReady ?
          <Typography className={classes.title} variant="h5">
            {Errorlabels("E_VERIFICATION_FAILURE")}
          </Typography>
          : <Skeleton />
        }
          <br />
          { contentReady ? (
          <div className={classes.content}>
            <Typography variant="subtitle2" className={classes.AlignLeft}>
              {E_VERFICATION_FAILURE_CONTENT1}
            </Typography>
            <EUserDetails
              E_VERIFICATION_FAILURE_ALERT_CONTENT={
                E_VERIFICATION_FAILURE_ALERT_CONTENT
              }
              Errorlabels={Errorlabels}
              classes={classes}
            />
            {supportNumber && supportMail && (
              <Typography
                variant="subtitle2"
                className={classes.AlignLeft}
                dangerouslySetInnerHTML={{
                  __html: E_VERFICATION_FAILURE_CONTENT2,
                }}
              />
            )}
          </div>)
          : (
            <div className={classes.emptyDiv}>
              <Skeleton variant="text" className={classes.Skeleton} />
              <Skeleton variant="rect" className={classes.Skeleton} />
            </div>
          )}
          <br />
          <Button
            className={classes.backSignup}
            onClick={backtosignup}
          >
          {
            errLabelReady ?
            <span>
              <ArrowBackIosIcon /> {Errorlabels("E_BACK_TO_REGISTER")}
            </span>
            : <Skeleton />
          }
          </Button> 
        </div>
      
    </>
  );
}
